import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';
import { reportClick } from '../../lib/reportEvent';

export default function SubcatBanner({
    index,
    link,
    title,
    image,
    categoryId,
    categoryName,
    subCategoryId,
    subCategoryName,
    position,
    pageCtxId
}) {
    const eventData = {
        categoryId,
        categoryName,
        subCategoryId,
        subCategoryName,
        title,
        position,
        pageCtxId
    };

    const imageBasePath = 'https://fiverr-res.cloudinary.com/w_iw_div_2.0,q_100,f_auto/general_assets/pro_experience/assets/images/f1/';
    const style = {
        backgroundImage: `url(${imageBasePath}${image})`
    };

    return (
        <a href={link}
            onClick={() => reportClick('pro_category_carousel', eventData)}
            className="subcat-banner"
            style={style}
            data-banner-id={index}>
            <i className="fiverr-pro-logo logo--small"/>
            <span>{title}</span>
        </a>
    );
}

SubcatBanner.propTypes = {
    link: PropTypes.string,
    title: PropTypes.string
};

SubcatBanner.defaultProps = {
    link: '',
    title: ''
};



// WEBPACK FOOTER //
// ./src/common/HomePage/SubcategoryBanners/SubcatBanner/index.js